import React from 'react';
import PropTypes from 'prop-types';

import { dig } from 'spiceutils';

import { Select } from 'spicecomponents';

const SingleSurvey = (props) => {
  const onChange = (value) => {
    if (value !== 'None') {
      props.onChange([value]);
    } else {
      props.onChange(null);
    }
  };

  return (
    <Select options={getOptions(props.controlList)} value={getValue(props.cdf)} onChange={onChange} />
  );
};

const getOptions = (controlList) => (
  [{ text: 'Default', value: 'None' }].concat(
    controlList.Options.map((survey) => ({
      value: survey,
    }))
  )
);

const getValue = (cdf) => (
  dig(cdf, ['SurveyList', 0]) || 'Value'
);

SingleSurvey.propTypes = {
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  onChange: PropTypes.func,
};

export default SingleSurvey;



// WEBPACK FOOTER //
// ./app/components/FormControls/SurveyList/SingleSurvey.js